import { Dialog, Typography } from "@mui/material";
import RouteIcon from "@mui/icons-material/Route";
import React, { useState } from "react";
import { Close } from "@mui/icons-material";
import CustomButton from "../../../reusableComponents/CustomButton";

function ConfirmAndReviewModal({ isOpen, setIsOpen , submitForm }) {
  const [loader, setLoader] = useState("");
  const handleKeyDownFallback = (event) => {
    if (event.key === "Escape") {
      setIsOpen(false);
    }
  };

  const handleSubmitForm = async (val) => {
    setLoader(val);
    await submitForm(val);
    setLoader("");
  };

  return (
    <Dialog
      open={isOpen}
      PaperProps={{
        style: {
          backgroundColor: "#FFF",
          borderRadius: "12px",
          width: "650px",
          maxWidth: "650px",
        },
      }}
      onKeyDown={handleKeyDownFallback}
    >
      <div className="">
        <div
          className="d-flex align-items-center w-100 justify-content-between"
          style={{ padding: "24px 24px 0px 24px" }}
        >
          <div
            className="d-flex align-items-center  justify-content-start"
            style={{ gap: 10 }}
          >
            <RouteIcon />
            <Typography
              sx={{
                color: "#1D1C20",
                fontWeight: 600,
              }}
            >
              Activate this rule for future transactions?{" "}
            </Typography>
          </div>
          <Close
            onClick={() => setIsOpen(false)}
            style={{ cursor: "pointer" }}
          />
        </div>
        <hr />

        <div className="px-4">
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 400,
              color: "#4F4D55",
              letterSpacing: "-0.1px",
            }}
          >
            Activating this rule will apply the specified conditions to all
            future transactions. You also have the option to save this rule in
            inactive state in the configuration history for later activation.
          </Typography>
        </div>
      </div>

      <div className="modalBottomBar">
        <CustomButton
          text={"Save as draft"}
          disabled={loader}
          loading={loader == "DRAFT"}
          onClick={() => handleSubmitForm("DRAFT")}
          variant={"outlined"}
          type={"secondary"}
        />
        <CustomButton
          text={"Activate"}
          disabled={loader}
          loading={loader == "ACTIVE"}
          onClick={() => handleSubmitForm("ACTIVE")}
          variant={"contained"}
          type={"secondary"}
        />
      </div>
    </Dialog>
  );
}

export default ConfirmAndReviewModal;
